import {
  ScheduleOutlined,
  CheckOutlined,
  StopOutlined,
} from '@ant-design/icons';
import { Row, Col, Card, Statistic } from 'antd';
import React from 'react';

interface ServiceStatsProps {
  services: any[];
}

const ServiceStats: React.FC<ServiceStatsProps> = (
  props: ServiceStatsProps,
) => {
  const { services } = props;
  return (
    <div
      style={{
        margin: '-32px',
        marginBottom: '32px',
        paddingBottom: '32px',
        background: '#f0f2f5',
      }}
    >
      <Row gutter={16} style={{ marginLeft: 'none', marginRight: 'none' }}>
        <Col span={4}>
          <Card>
            <Statistic
              title="Programados"
              value={services.length}
              precision={0}
              prefix={<ScheduleOutlined translate={undefined} />}
            />
          </Card>
        </Col>
        <Col span={4}>
          <Card>
            <Statistic
              title="Finalizados"
              value={`${
                services.filter((service) => service.status === 'closed').length
              } (${
                services.length &&
                (
                  (services.filter((service) => service.status === 'closed')
                    .length /
                    services.length) *
                  100
                ).toFixed(0)
              } %)`}
              valueStyle={{ color: '#3f8600' }}
              prefix={<CheckOutlined translate={undefined} />}
            />
          </Card>
        </Col>
        <Col span={4}>
          <Card>
            <Statistic
              title="Anulados"
              value={`${
                services.filter((service) => service.status === 'cancelled')
                  .length
              } (${
                services.length &&
                (
                  (services.filter((service) => service.status === 'cancelled')
                    .length /
                    services.length) *
                  100
                ).toFixed(0)
              } %)`}
              valueStyle={{ color: '#cf1322' }}
              prefix={<StopOutlined translate={undefined} />}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ServiceStats;
